import { DefaultTheme } from 'styled-components'

const zIndexes: DefaultTheme['zIndexes'] = {
    popover: 5000,
    modal: 6000,
}

export default zIndexes
